// src/components/ViewStream.js
import React, { useRef, useState, useEffect } from "react";
import { ZegoExpressEngine } from "zego-express-engine-webrtc";
import { GetStreamToken } from "../services/cms.service";

const appID = 861136410;
const server = "wss://webliveroom861136410-api.coolzcloud.com/ws";
const roomID = "test-room";
const userID = "2222";
const userName = "viewer_" + userID;
const publisherUserID = "690c7648823c236cb04b0ed6";
const streamID = "stream_" + publisherUserID; // must match publisher’s stream ID

function ViewStream() {
  const remoteVideoRef = useRef(null);
  const [engine, setEngine] = useState(null);
  const [isViewing, setIsViewing] = useState(false);

  const startViewing = async () => {
    try {
      console.log("🎬 Starting viewer process...");

      // ✅ Initialize Zego engine
      const zg = new ZegoExpressEngine(appID, server);
      setEngine(zg);

      // ✅ Token (viewer)
      const res = await GetStreamToken(userID, roomID);

      console.log("Token API response view:", res);

      const token = res.token;
      // ✅ Listen for stream updates
      zg.on("roomStreamUpdate", async (roomID, updateType, streamList) => {
        console.log("📡 Stream update:", { updateType, streamList });

        if (updateType === "ADD") {
          // ✅ A publisher went live
          const matchingStream = streamList.find(
            (s) => s.streamID === streamID
          );
          if (matchingStream && !isViewing) {
            console.log("🎥 Publisher is live! Starting playback...");
            const remoteStream = await zg.startPlayingStream(streamID);
            if (remoteVideoRef.current) {
              remoteVideoRef.current.srcObject = remoteStream;
            }
            setIsViewing(true);
          }
        }

        if (updateType === "DELETE") {
          // 🛑 Stream ended
          alert("⚠️ Stream has ended.");
          stopViewing();
        }
      });

      console.log("Login Params → view", {
        roomID,
        userID,
        userName,
        token,
      });

      // ✅ Login to the room
      await zg.loginRoom(roomID, token, { userID, userName });
      console.log("✅ Logged into room:", roomID);

      // ✅ After login, check if any streams already exist
      const existingStreams = await zg.getRoomStreamList(roomID);
      console.log("🔍 Existing streams:", existingStreams);

      const activeStream = existingStreams.find((s) => s.streamID === streamID);
      if (activeStream) {
        console.log("🎥 Publisher already live — playing now...");
        const remoteStream = await zg.startPlayingStream(streamID);
        if (remoteVideoRef.current) {
          remoteVideoRef.current.srcObject = remoteStream;
        }
        setIsViewing(true);
      } else {
        console.warn("🚫 No live stream found. Waiting for publisher...");
        alert("Stream not live yet. Viewer will auto-join when it starts!");
      }
    } catch (error) {
      console.error("❌ Error starting viewer:", error);
    }
  };

  const stopViewing = async () => {
    try {
      if (engine) {
        await engine.stopPlayingStream(streamID);
        await engine.logoutRoom(roomID);
        engine.destroyEngine();
        setEngine(null);
      }
      if (remoteVideoRef.current) {
        remoteVideoRef.current.srcObject = null;
      }
      setIsViewing(false);
      console.log("✅ Viewer stopped and cleaned up.");
    } catch (error) {
      console.error("❌ Error stopping viewer:", error);
    }
  };

  useEffect(() => {
    return () => {
      if (isViewing) stopViewing();
    };
  }, [isViewing]);

  return (
    <div style={{ textAlign: "center" }}>
      <h2>View Live Stream</h2>
      <video
        ref={remoteVideoRef}
        autoPlay
        playsInline
        controls
        width="800"
        style={{ borderRadius: "10px", boxShadow: "0 0 10px #ccc" }}
      />
      <br />
      {!isViewing ? (
        <button
          style={{
            margin: "10px",
            backgroundColor: "#007bff",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
          }}
          onClick={startViewing}
        >
          Join & Watch Stream
        </button>
      ) : (
        <button
          style={{
            margin: "10px",
            backgroundColor: "#dc3545",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
          }}
          onClick={stopViewing}
        >
          Leave Stream
        </button>
      )}
    </div>
  );
}

export default ViewStream;
